module.exports = __webpack_public_path__ + "static/media/Library_6.eea49627.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/library/Library_6.png
// module id = 1293
// module chunks = 3